import React, { FC } from 'react';

import { EvTitle } from '@evinced-private/ui-common';

import {
	FILE_TYPE_DESCRIPTION_ID,
	FILE_TYPE_SETTINGS_TITLE_ID
} from './FileTypeSettingsV2.constants';
import { FILE_TYPE_LABELS, FILE_TYPE_MORE_INFO } from './FileTypeSettingsV2.labels';

export const FileTypeSectionHeader: FC = () => (
	<div className="section-header">
		<div className="title">
			<EvTitle
				titleText={FILE_TYPE_LABELS.SECTION_TITLE}
				MoreInfoContent={FILE_TYPE_MORE_INFO}
				id={FILE_TYPE_SETTINGS_TITLE_ID}
				descriptionId={FILE_TYPE_DESCRIPTION_ID}
			/>
		</div>
	</div>
);
